import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import TFIcon from './TFIcon';
/**
 * `TFIconSlot` → renderable element. Primitive adapters use this.
 *
 * A string resolves through the registry (preferred path); a ready element
 * passes through unchanged — this is the escape hatch that keeps old call
 * sites carrying `icon={<Icon iconName='X'/>}` working during migration.
 */ export var resolveIcon = function resolveIcon(slot, size) {
    if (!slot) return undefined;
    if (typeof slot === 'string') return /*#__PURE__*/ _jsx(TFIcon, {
        name: slot,
        size: size
    });
    return slot;
};
